import router from "@/router/index"
import store from "@/store"
import { ElMessage } from 'element-plus'


/**路由守卫，每次请求都要先在这里进行判断 */
router.beforeEach((to, from, next) => {

    const whiteList = [
        '/',
        '/index',

        // 标准检索路由
        '/front/standardsearch/standardSeniorSearch',
        '/front/standardsearch/standardBusiness',
        '/front/standardsearch/standardBusinessDetail',
        '/front/standardsearch/standardTeam',
        '/front/standardsearch/standardTeamDetail',
        '/front/standardsearch/standardCommonSearch',
        '/front/standardsearch/standardSearchResult',
        '/front/standardsearch/standardSearchResultDetail',
        '/front/standardsearch/standardSearchResultDetail2',
        '/front/standardsearch/standardShanghaiBusiness',

        // 专题检索路由
        '/front/topicsearch/specialSubjectSearch',
        '/front/topicsearch/standardLogistics',
        '/front/topicsearch/topicCityRefine',
        '/front/topicsearch/topicCityRefineDetail',
        '/front/topicsearch/topicFoodSafety',
        '/front/topicsearch/businessstdTest',

        // 商务诚信专题库路由及其子路由
        '/front/topicsearch/businessstdIndex',
        '/front/topicsearch/businessstdIndexContent',
        '/front/topicsearch/businessstdTitleList',
        '/front/topicsearch/businessstdTitleDetail',
        '/front/topicsearch/businessstdTable',

        // 信息发布路由
        '/front/inforelease/infoRelease',
        '/front/inforelease/infoImplementation',
        '/front/inforelease/infoObsolete',
        '/front/inforelease/infoWorkUpdate',

        // 国际合作路由
        '/front/international/internationAstm',
        '/front/international/internationAstmStandardSearch',
        '/front/international/internationAstmInfo',
        '/front/international/internationAstmGreeting',
        '/front/international/internationBsi',
        '/front/international/internationAbroadIssue',

        // 服务引导路由
        '/front/serviceguide/serviceCollectionType',
        '/front/serviceguide/serviceMajorProduct',
        '/front/serviceguide/serviceUsAbout',

        // 个人中心路由
        '/front/personalcenter/tLogin',
        '/front/personalcenter/tRegisterHint',
        '/front/personalcenter/tRegister',

        // 新增模块
        '/front/news/knowCorpus',
        '/front/news/knowCorpusSenior',
        '/front/news/knowGraph',
        '/front/news/knowGraphList',
        '/front/news/knowGraphTerm',
        '/front/news/knowGraphTermDetail',
        '/front/news/knowGraphSenior',
        '/front/news/xmlDocumentCompare',
        '/front/news/xmlDocumentCompare1',
        '/front/news/xmlDocumentCompare2',
        '/front/news/xmlDocumentCompare3',
        '/front/news/xmlDocumentRead',
        '/front/news/xmlDocumentRead2',
        '/front/news/xmlDocumentRead3',
        '/front/news/graphDetails',
        '/front/news/ofdDocumentRead',  
        '/front/news/ofdDocumentReadStandard',  
        '/front/news/ofdDocumentReadBusiness',
        '/front/news/ofdDocumentShangHaiRead',
        '/front/news/descTest',      

        //忘记密码、忘记密码&重置密码、注册激活
        '/front/personalcenter/tRegisterForget',
        '/front/personalcenter/tRegisterForgetUpdate',
        '/front/personalcenter/tRegisterActivate',
        '/front/personalcenter/tPersonnalInstallHelp',      
        '/front/personalcenter/tPersonnalInstallHelpGuide', 

        '/go',
        '/front/news/searchServiceHelp',
        '/sds/InformationDelivery/standCollVar',
        '/sds/MemberServices/howtobvip',
        '/sds/purchaseProcess',
        '/sds/internationalOperation/standardsBooks',
        '/sds/stanService/serviceHelp',

        '/SDSHub/SmartSearch/SmartHome'
    ];

    // 判断是否登录
    const token = store.getters.GET_TOKEN;

    if (token) {
        next();
    } else {
        if (whiteList.includes(to.path)) {
            // to.meta.keepAlive = false
            next();
        } else {
            // to.meta.keepAlive = false
            //这个用作登录拦截的
            //next();
            ElMessage.error('您还未登录,请先登录')
            router.push({
                path: '/front/personalcenter/tLogin',
                query: {
                    date: new Date().getTime()
                }
            })
        
        }
    }
})